import { FormattedMessage } from 'react-intl';
import {
  Box,
  Container,
  Link,
  List,
  Li,
  Anchor,
  I18NLogOut,
  H2
} from '../../components';
import { useAuth } from '../../lib/with-auth';
import { Router, match } from '../../lib/routes';
import * as messages from './messages';
import { i18nMessages } from '../../components/common-i18n';
import { NextRouter } from 'next/router';
import { useSystem } from '../../lib/core/useSystem';
import { useMemo } from 'react';
//import { useStaticDataSystem } from '../../lib/core/staticDataQuery';

//const PIN_CODE_ROUTE = 'profile.pin-code';

const FooterNav = ({ url }: { url: NextRouter }) => {
  const system = useSystem();
  const { logOut } = useAuth();
  //const staticDataSystem = useStaticDataSystem();

  const profileMenuItems = useMemo(
    () => [
      {
        route: 'profile',
        testId: '',
        label: messages.sections.subscription
      },
      {
        route: 'profile.personal-info',
        testId: '',
        label: messages.sections['personal-info']
      },
      {
        route: 'profile.trips',
        testId: 'Profile__SectionsNav__Trips',
        label: messages.sections['tripHistory']
      },
      {
        route: 'profile.receipts',
        testId: '',
        label: messages.sections['receipts']
      },
      {
        route: 'profile.invoices',
        testId: 'Profile__SectionsNav__Invoices',
        label: messages.sections['invoices']
      },
      {
        route: 'profile.credit-cards',
        testId: 'Profile__SectionsNav__CreditCards',
        label: messages.sections['credit-cards']
      },
      {
        route: 'profile.wallet',
        testId: 'Profile__SectionsNav__wallet',
        label: messages.sections['wallet'],
        visible: Boolean(
          system?.walletEnablement === 'opt_in' ||
            system?.walletEnablement === 'forced'
        )
      },
      {
        route: 'profile.assign-rfid-card',
        testId: 'Profile__SectionsNav__AssignRfidCard',
        label: messages.sections['assign-rfid-card'],
        visible: Boolean((system?.rfidAssignMethod?.length || 0) > 0)
      },
      // We do not have systems which support PIN code functionality currently.
      // {
      //   route: PIN_CODE_ROUTE,
      //   testId: 'Profile__SectionsNav__PinCode',
      //   label: messages.sections['pin-code']
      // },
      {
        route: 'profile.your-data',
        testId: 'Profile__SectionsNav__YourData',
        label: messages.sections['your-data']
      }
    ],
    [system?.id]
  );

  let profileMenu = [...profileMenuItems];

  // if (
  //   (staticDataSystem && !staticDataSystem.usersCanUnlockWithPinCode)
  // ) {
  //   profileMenu = profileMenuItems.filter(
  //     ({ route }) => route !== PIN_CODE_ROUTE
  //   );
  // }

  const routeMatch = match(url.asPath);

  return (
    <Box data-testid="Profile__FooterNav" bg="neutral.1" py={7} mt={7}>
      <Container variant="narrow" textAlign="center">
        <H2 small mb="xs" fontWeight="normal">
          <FormattedMessage {...i18nMessages.profile} />
        </H2>
        <List>
          {profileMenu.map(item => {
            return item.visible === false ? null : (
              <Li key={item.route} mb="xxs">
                <Link route={item.route} passHref>
                  <Anchor
                    data-testid={item.testId}
                    textDecoration="none"
                    typoStyle="sm"
                    color={
                      routeMatch.route.name === item.route
                        ? 'neutral.4'
                        : undefined
                    }
                  >
                    <FormattedMessage {...item.label} />
                  </Anchor>
                </Link>
              </Li>
            );
          })}
          <Li>
            <Anchor
              data-testid="Profile__FooterNav__LogOut"
              onClick={async () => {
                await logOut();
                // redirect home after logOut
                Router.pushRoute('home');
              }}
              textDecoration="none"
              typoStyle="sm"
            >
              <I18NLogOut />
            </Anchor>
          </Li>
        </List>
      </Container>
    </Box>
  );
};

export default FooterNav;
